import { PropsWithChildren, createContext, useContext } from "react"
import { useAuth } from "m2m-components/storage/useM2mAuth"
import { useParams } from "react-router-dom"
import { Operation } from "@/model/operation"
import { assertIsDefined } from "@/utils/assetIsDefined"
import { useOperation } from "@/hooks/useOperaion"

export interface OperationInfoContextState {
    operationId: string
    operation?: Operation
    refetch: () => void
    fieldWidth: number
}

export const OperationInfoContext = createContext<
    OperationInfoContextState | undefined
>(undefined)

export const useOperationInfoCtx = () => {
    const ctx = useContext(OperationInfoContext)
    if (!ctx) {
        throw new Error(
            "useOperationInfoCtx must be used within a OperationInfoProvider"
        )
    }

    return ctx
}

export const OperationInfoProvider = ({ children }: PropsWithChildren) => {
    const { token } = useAuth()
    const { operationId } = useParams<{ operationId: string }>()

    assertIsDefined(operationId)

    const { data: operation, refetch } = useOperation(token, operationId)

    return (
        <OperationInfoContext.Provider
            value={{
                operationId,
                operation,
                refetch,
                fieldWidth: 375
            }}
        >
            {children}
        </OperationInfoContext.Provider>
    )
}
